import script from "./AddCallsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCallsModal.vue?vue&type=script&setup=true&lang=js"

import "./AddCallsModal.vue?vue&type=style&index=0&id=70744a27&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70744a27"]])

export default __exports__